/**
 * Barras de pontuação — funciona para pilares BS4IT (peso/normalizado) e
 * domínios IGA (score/max_score).
 */
export type BarItem = {
  key: string
  label: string
  value: number        // pontuação atual
  max: number          // máximo possível
  color?: string
  hint?: string        // ex: "Peso 25%"
}

const DEFAULT_COLORS = ['#06b6d4', '#8b5cf6', '#ef4444', '#f59e0b', '#10b981', '#3b82f6']

export default function PillarBars({
  title = 'Pontuação',
  items,
}: { title?: string; items: BarItem[] }) {
  return (
    <section>
      <h2 className="text-xl font-bold mb-4 text-white">{title}</h2>
      <div className="space-y-3">
        {items.map((it, i) => {
          const color = it.color || DEFAULT_COLORS[i % DEFAULT_COLORS.length]
          const pct = it.max > 0 ? (it.value / it.max) * 100 : 0
          return (
            <div key={it.key} className="bg-slate-900/60 border border-slate-800 rounded-xl p-4">
              <div className="flex items-center justify-between mb-2">
                <div>
                  <p className="text-sm font-bold text-white">{it.label}</p>
                  {it.hint && <p className="text-[10px] text-slate-500">{it.hint}</p>}
                </div>
                <div className="text-right">
                  <span className="text-lg font-bold" style={{ color }}>
                    {Number.isInteger(it.value) ? it.value : it.value.toFixed(1)}
                  </span>
                  <span className="text-xs text-slate-500"> / {it.max}</span>
                </div>
              </div>
              <div className="h-2 bg-slate-800 rounded-full overflow-hidden">
                <div className="h-full rounded-full transition-all"
                  style={{ width: `${Math.min(pct, 100)}%`, background: color }} />
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
